import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { Product } from "../../domain/models/product";
import { ProductPortalRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetProductsUsecase implements UseCase<null, Product[]> {

  constructor(private readonly productPortalRepository: ProductPortalRepository) {
  }

  execute(): Observable<Product[]> {
    return this.productPortalRepository.getProducts();
  }

}
